// Split view's own layer picker (Josh, 21 Oct 2026, Option A).
//
// Saved per person, per show at users/{uid}.projects.{pid}.layers.splitViewing (array of layer
// ids), next to viewing / listViewing / showNotes / showCues.
// - Absent: the split list follows the script's layers (layers.viewing), live, as it always has.
// - The first click in the picker writes the whole array; from then on it is independent.
// - Ids of layers that no longer exist are ignored when read.
// The full List view (listViewing), Work Notes panel and print nav are not affected.

export function followsScript(layersData) {
    return !(layersData && Array.isArray(layersData.splitViewing));
}

// The layer ids the split list shows. `existingIds` = the show's current layer ids.
export function splitLayerIDs(layersData, existingIds) {
    if (!layersData) return [];
    const source = followsScript(layersData) ? (layersData.viewing || []) : layersData.splitViewing;
    const exists = new Set(existingIds || []);
    return source.filter(id => exists.has(id));
}

// The whole array to save after one checkbox click, in menu order (`allIdsInOrder`).
export function toggledSplitLayerIDs(shownIds, allIdsInOrder, id, on) {
    const shown = new Set(shownIds || []);
    return (allIdsInOrder || []).filter(layerId => (layerId === id ? on : shown.has(layerId)));
}

// Button label after "Layers: ".
export function splitLayersLabel(shownCount, totalCount) {
    return shownCount >= totalCount ? 'All' : shownCount + ' of ' + totalCount;
}

// A new layer switches on in its creator's split list. Only when they have a saved choice:
// while following, it arrives through the script, and an arrayUnion on the absent field would
// create [newId] and hide every other layer.
export function addsNewLayerToSplit(layersData) {
    return !followsScript(layersData);
}


// WEBPACK FOOTER //
// ./src/lib/split-layers.js